module.exports = __webpack_public_path__ + "media/bootstrap-icons/question-diamond-fill-3744c501.svg";